import { runtimeConfig } from './runtimeConfig';

export function getBrowserRouterBasePath(): string {
  const browserRouter = runtimeConfig.browserRouter;
  if (!browserRouter) return '';

  const normalizedPath = browserRouter.startsWith('/') ? browserRouter : `/${browserRouter}`;

  return normalizedPath.replace(/\/$/, '');
}

export function getPublicAssetPath(path: string): string {
  const basePath = getBrowserRouterBasePath();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${basePath}${normalizedPath}`;
}
